import React, { useEffect } from "react";
import {
  Row,
  Col,
  ProgressBar,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import styles from "./MonthTimeLine.module.css";
import momentTz from 'moment-timezone'
import { useSelector, useDispatch } from "react-redux";
import { changeSelectedDay } from "./../../Slices/candidateSlice";
import { useLocation, useNavigate } from "react-router-dom";

const MonthTimeLine = (props) => {
  const { month } = props;
  const { monthTimeline, selectedDay } = useSelector(
    (state) => state.candidateSlice
  );
  const { sessionUser: { timezone } } = useSelector(
    (state) => state.sessionSlice
  );
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const Day = (props) => {
    const { day, isLastDayOfMonth, workDurationInMinutes } = props;
    const hours = Math.floor(workDurationInMinutes / 60);
    const min = workDurationInMinutes - hours * 60;
    const workDurationForTooltip =
      hours > 0 ? hours + " hr " + min + " min" : min + " min";

    const isToday = momentTz().tz(timezone).isSame(momentTz(month).tz(timezone).date(day), "day");

    // const isTomarrow = moment(month).date(day).isAfter(month, "day");

    const progressBarNow = Math.floor(workDurationInMinutes / 6);

    // Use timezone-aware comparison instead of string parsing
    const selectedDayInTimezone = selectedDay ? momentTz(selectedDay).tz(timezone) : null;
    const dayInTimezone = momentTz(month).tz(timezone).date(day);
    const isTodaySelected = selectedDayInTimezone && selectedDayInTimezone.isSame(dayInTimezone, "day");
    const getBorderClass = () => {
      if (isTodaySelected) {
        return `border border-primary border-2 rounded-top rounded-bottom ${styles.today}`;
      }
      // if (isTomarrow) {
      //   return `${styles.tomarrow}`;
      // }
      if (isLastDayOfMonth) {
        return `${styles.lastDay}`;
      }
      // ordinary day
      return `${styles.border}`;
    };

    const dispatch = useDispatch();

    const getWeekDayClassName = (day) => {
      if (["Sat", "Sun"].includes(day)) {
        return `${styles.weekend} text-danger`;
      }
      return "";
    };

    const dayShortName = momentTz(month).tz(timezone).date(day).format("ddd");

    return (
      <>
        <OverlayTrigger
          className={`${styles.minWidth}`}
          placement="top"
          overlay={
            <Tooltip id="button-tooltip-2">{workDurationForTooltip}</Tooltip>
          }
        >
          {({ ref, ...triggerHandler }) => (
            <div
              {...triggerHandler}
              className={`${getBorderClass()}`}
              onClick={() => {
                // Use month (displayed month/year) as base - momentTz() would use current year incorrectly
                const dayInTimezone = momentTz(month).tz(timezone).date(day).startOf("day");
                dispatch(changeSelectedDay(dayInTimezone.toISOString()));
                // Update URL with date in YYYY-MM-DD format
                const date = dayInTimezone.format('YYYY-MM-DD');
                // Only sync URL when used on candidate screenshots page
                if (pathname.includes('candidateScreenshots')) {
                  const params = new URLSearchParams(search);
                  params.set('date', date);
                  navigate(`${pathname}?${params.toString()}`, { replace: true });
                }
              }}
            >
              <div ref={ref} className={getWeekDayClassName(dayShortName)}>
                {dayShortName}
              </div>
              <div>{day}</div>
              <div>
                <ProgressBar
                  className={`${styles.progress}`}
                  variant="success"
                  now={progressBarNow}
                />
              </div>
            </div>
          )}
        </OverlayTrigger>
      </>
    );
  };

  return (
    <>
      <>
        <Row className="p-0">
          {monthTimeline.map((day, index, array) => {
            const progress = day.duration;
            return (
              <>
                <Col
                  className={`p-0 text-center ${styles.small_text} ${styles.cursor_pointer}`}
                >
                  <Day
                    day={day.day}
                    workDurationInMinutes={progress}
                    isLastDayOfMonth={array.length - 1 === index ? true : false}
                  />
                </Col>
              </>
            );
          })}
        </Row>
      </>
    </>
  );
};

export default MonthTimeLine;
